import React from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { LiveStatusBadge } from "./LiveStatusBadge";
import _ from "lodash";
import TeamLogo from "../TeamLogo";
import frontend from "../../../../../config/frontend";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";
import { isBildMatchFinished, isBildMatchLive } from "./bildMatchLive";


const MatchTime = ({ matchInfo, timeMin, t }) => {
    const matchTime = _.get(matchInfo, "matchTime", timeMin);
    return matchTime && (
        <span className={"match-score-time"}>
            {matchTime}.{t("min")}
        </span>
    )

};

export const MatchScoreWidget = ({
    homeTeam,
    awayTeam,
    matchInfo = {},
    hideLive = false,
    isAlarm = false,
    showScore = false,
    timeMin = ""
}) => {
    // const hasPenalty = _.has(matchDetails, "scores.pen");
    const { finished, live_status, match_result } = matchInfo;
    const scores = {
        home: match_result?.find((m) => m.match_result_at === '0' && m.place === 'home')?.match_result,
        away: match_result?.find((m) => m.match_result_at === '0' && m.place === 'away')?.match_result,
    }
    const { t } = useTranslation();
    const isPlaying = isBildMatchLive(matchInfo?.match_date, matchInfo?.match_time, finished)
    const isTimeFinished = isBildMatchFinished(matchInfo?.match_date, matchInfo?.match_time);
    return (
        <div className={"comp-match-score-widget"}>
            <div className={"widget-container"}>
                <div className={`logo-container home ${isAlarm ? "isAlarm" : ""}`}>
                    <BildTeamLogo
                        className="team-logo"
                        id={homeTeam?.id}
                    />
                    <div className={"team-name home"}>
                        {t(homeTeam?.name, { ns: "countries" })}
                    </div>
                </div>
                {finished === 'yes' || (isPlaying || isTimeFinished)
                    ? (
                        <div className="score-container">
                            <div className={"score"}>
                                <div className={"score-home"}>{scores?.home || 0}</div>
                                <div className={"separator"}>{":"}</div>
                                <div className={"score-away"}>{scores?.away || 0}</div>
                                {(!isAlarm && isPlaying && !hideLive) && <LiveStatusBadge />}
                            </div>
                            {(isPlaying && !hideLive) || (timeMin !== "") ? (
                                <MatchTime
                                    matchInfo={matchInfo}
                                    timeMin={timeMin}
                                    t={t}
                                />
                            ) : null}
                        </div>
                    ) : (
                        <div className={"team-vs"}>
                            <div className={"versus"}>{t("templates.vs")}.</div>
                        </div>
                    )}
                <div className={`logo-container away ${isAlarm ? "isAlarm" : ""}`}>
                    <BildTeamLogo
                        className="team-logo"
                        id={awayTeam?.id}
                    />
                    <div className={"team-name away"}>
                        {t(awayTeam?.name, { ns: "countries" })}
                    </div>
                </div>
            </div>
        </div>
    );
};
